import type { ToolHandle } from '@toolproof-core/genesis/_contract/_index';

type Example = { inputs: Record<string, number | boolean>; outputs: Record<string, number | boolean> };

export const CONCEPT_INVOCATION_EXAMPLES: Partial<Record<ToolHandle, Example>> = {
    'TOOL-BooleanIdentity': { inputs: { In: true }, outputs: { Out: true } },
    'TOOL-LogicalAnd': { inputs: { OperandOne: true, OperandTwo: false }, outputs: { Result: false } },
    'TOOL-LogicalNAnd': { inputs: { OperandOne: true, OperandTwo: false }, outputs: { Result: true } },
    'TOOL-LogicalOr': { inputs: { OperandOne: true, OperandTwo: false }, outputs: { Result: true } },
    'TOOL-LogicalNOr': { inputs: { OperandOne: true, OperandTwo: false }, outputs: { Result: false } },
    'TOOL-LogicalXOr': { inputs: { OperandOne: true, OperandTwo: false }, outputs: { Result: true } },
    'TOOL-LogicalXNor': { inputs: { OperandOne: true, OperandTwo: false }, outputs: { Result: false } },
    'TOOL-LogicalNot': { inputs: { Operand: true }, outputs: { Result: false } },
    'TOOL-NaturalIdentity': { inputs: { In: 8 }, outputs: { Out: 8 } },
    'TOOL-NaturalLessThan': { inputs: { LessThanSource: 3, LessThanTarget: 5 }, outputs: { LessThanDecision: true } },
    'TOOL-NaturalAdd': { inputs: { AddendOne: 3, AddendTwo: 5 }, outputs: { Sum: 8 } },
    'TOOL-NaturalSubtract': { inputs: { Minuend: 8, Subtrahend: 3 }, outputs: { Difference: 5 } },
    'TOOL-NaturalMultiply': { inputs: { Multiplier: 3, Multiplicand: 5 }, outputs: { Product: 15 } },
    'TOOL-NaturalDivide': { inputs: { Dividend: 17, Divisor: 5 }, outputs: { Remainder: 2, Quotient: 3 } },
    'TOOL-NaturalDouble': { inputs: { Multiplier: 2, Multiplicand: 5 }, outputs: { Product: 10 } },
};
